<template>
    <div
        v-show="show_data" 
        :class="[
            {absolute: absolute},
            {preview: preview},
        ]"    
        class="availability-list-container" 
    >
        <div class="relative">
            <div class="relative">
                <input 
                    type="text" 
                    placeholder="e.g. 4000, Brisbane" 
                    v-model="search" 
                    @keyup="searchAddresses"
                    v-show="show_search_address"
                />
                <SvgSearch :show="!searching && show_search_address"></SvgSearch>
                <div class="spinner" v-show="searching && show_search_address">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                </div>
                <ul class="address-list" v-show="display_addresses">
                    <li v-if="addresses.length === 0">Postcode / Suburb Not Found</li>
                    <li 
                        v-for="(address, index) in addresses" 
                        :key="`address-${address.postcode}-${address.locality}-`+index"
                        @click="searchStockists(address.postcode, address.locality, address.state)"
                    >{{ address.locality }}, {{ address.postcode }}, {{ address.state }}</li>
                </ul>
                <div class="availability-list" :class="[{catalogue: value === 'stockist'}]">
                    <div 
                        v-for="(stockist, index) in stockist_arr"
                        :key="`stockist-`+index+stockist.note" 
                        class="stockist-option" 
                        :class="{ active: id_data == stockist.id }"
                    >
                        <div class="title-wrapper">
                            <div>
                                <h4>{{ stockist.name }}</h4>
                                <span>  ({{ stockist.distance }}km)</span>
                            </div>
                            <div class="d-flex" v-if="!preview">
                                <div class="tooltip" v-if="!stockist.clickcollect && value !== 'stockist'">
                                    <a class="alert" ref="alert"><SvgAlert></SvgAlert></a>
                                    <div ref="tooltip" id="tooltip" class="tooltiptext">
                                        <span v-if="id_data != stockist.id && stockist.note != '' && !stockist.clickcollect">Please remove {{ stockist.note }} from your cart</span>
                                        <span v-else>Click and collect not available for this product</span>

                                    <div id="arrow" data-popper-arrow></div>
                                    </div>
                                </div>
                            
                                <div class="link" v-if="value === 'stockist'">
                                    <a class="link relative google-link" :href="GOOGLE_MAP_LINK+stockist.address" target="_blank"><SvgDirection></SvgDirection>Take me there</a>
                                </div>
                                <div 
                                    class="alert" 
                                    v-else-if="id_data != stockist.id && stockist.note != '' && !stockist.clickcollect && value !== 'stockist'"
                                >
                                    UNAVAILABLE
                                </div>
                                <a 
                                    class="link stockist-link" 
                                    v-else 
                                    @click="changeStockist(stockist.id)"
                                >
                                    {{ id_data == stockist.id ? 'My stockist' : 'Set as my stockist' }}
                                </a>
                            </div>
                            <div class="d-flex" v-else>
                                <div class="link-wrapper">
                                    <!-- <a class="link" @click="changeStockist(stockist.id)">{{ id_data == stockist.id ? 'My stockist' : 'Set as my stockist' }}</a> -->
                                    <a class="link relative" :href="GOOGLE_MAP_LINK+stockist.address" target="_blank"><SvgDirection></SvgDirection>Take me there</a>
                                </div>
                            </div>
                        </div>

                        <div class="content relative"><SvgMarker></SvgMarker><span>{{ stockist.address }}</span></div>
                        <div class="content relative"><a :href="'tel:' + stockist.phone"><SvgPhone></SvgPhone><span>{{ stockist.phone }}</span></a></div>

                        <div><a href="javascript:void(0)" class="email-stockist" @click="emailStockist(stockist)">Email Stockist</a></div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import SvgMarker from './SvgMarker.vue';
import SvgPhone from './SvgPhone.vue';
import SvgAlert from './SvgAlert.vue';
import SvgDirection from './SvgDirection.vue';
import debounce from "lodash.debounce";
import SvgSearch from './SvgSearch.vue';

import axios from 'axios';

    const AJAX_URL = '/wp-admin/admin-ajax.php';
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    export default {
        name: 'ProductAvailabilityList',
        components: {
            SvgMarker,
            SvgPhone,
            SvgAlert,
            SvgDirection,
            SvgSearch
        },
        props: {
            stockists: Array,
            show: Boolean,
            id: Number,
            absolute: {
                type: Boolean,
                default: false
            },
            preview: {
                type: Boolean,
                default: false
            },
            type: String,
            value: {
                type: String,
                default: ""
            },
            full_list: {
                type: Array,
                default: () => []
            },
            show_search_address: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {
                stockist_arr: [],
                show_data: false,
                id_data: '',
                absolute_data: false,

                // address search
                search: "",
                prev_search: "",
                searching: false,
                selected_suburb: '',
                addresses: [],
                display_addresses: false
            }
        },
        methods: {
            searchStockists: function(postcode, locality, state) {
                const self = this;
                const { preferred } = self;

                // hide addresses list
                self.display_addresses = false;
                this.search = `${locality}, ${postcode}, ${state}`;
                this.selected_suburb = this.capitalize(locality);

                if (postcode != '') {
                    self.searching = true;

                    axios.post(AJAX_URL, {
                        action: 'ajax_get_stockist',
                        postcode: postcode,
                        locality: locality,
                        state: state,
                        product_id: ""
                    })
                    .then(function (response) {
                        const { stockists } = response.data; 
                        const _preferred = stockists.find(s => s.id == preferred);

                        let stockist_arr = self.trimStockists(stockists, _preferred);
                        self.stockist_arr = stockist_arr;
                        self.show_data = true;
                        self.searching = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });    
                } else {
                    self.display_addresses = false;
                }
            },
            searchAddresses: debounce(function () {
                const self = this;
                const { search, prev_search } = self;

                // search address if user input more than 3 characters
                if (search.length >= 3 && search != prev_search) {
                    self.searching = true;
                    self.prev_search = search;

                    axios.post(AJAX_URL, {
                        action: 'ajax_get_address',
                        address: search,
                    })
                    .then(function (response) {
                        const { addresses } = response.data;

                        self.addresses = addresses;
                        self.searching = false;
                        // show addresses list
                        self.display_addresses = true;

                        if (addresses.length === 0) {
                            setTimeout(function () {
                                self.display_addresses = false;
                            }, 3000);
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });   
                } else if (search.length === 0) {
                    // clear address list
                    self.display_addresses = false;
                    self.addresses = [];
                }
            }, 500),
            changeStockist: function (id) {
                this.id_data = id;
                const { type } = this;
                var self = this;

                if (type == 'side-cart' || type == 'cart') {
                    document.querySelector("pp-overlay").setAttribute( 'show', "true");

                    /**
                     * Update the selected store in WC session & refresh the side cart fragment
                     */
                    axios.post(AJAX_URL, {
                        action: 'ajax_cart_change_stockist',
                        key: 'selected-store',
                        value: id
                    }).then(function (resp) {
                        const{ stockist_changed } = resp.data;

                        if (type == 'side-cart') {
                            axios.post('/?wc-ajax=get_refreshed_fragments')
                            .then(function (response) {
                                const cart_content = document.querySelector('div.widget_shopping_cart_content');

                                if (cart_content) {
                                    cart_content.outerHTML = response.data['fragments']['div.widget_shopping_cart_content'];
                                }

                                if (!stockist_changed) {
                                    // update side store name
                                    var selected = self.stockist_arr.find(e => e.id == id);
                                    document.querySelector("#selected-store").innerHTML = selected['name'];
                                }

                                const pa = document.querySelector("product-availability");

                                if (pa) {
                                    // update product availabilty details
                                    pa.setAttribute( 'preferred', id);
                                }

                                // close stockists list
                                self.show_data = 0;

                                // close overlay
                                document.querySelector("pp-overlay").setAttribute( 'show', false);
                                
                            })
                        } else {
                            self.show_data = 0;
                            document.querySelector("button[name='update_cart']").disabled = false;
                            document.querySelector("button[name='update_cart']").click();
                        }

                    })

                } else {
                    this.$emit('change-stockist', id);
                }
            },
            trimStockists: function (stockists, _preferred) {
                let stockist_arr = stockists;
                const { preview } = this;

                if (!_preferred) {
                    _preferred = stockist_arr[0];
                } else {
                    // COMMENT THIS SECTION AS IT IS NOT SHOWING NEAREST STOCKIST
                    // const foundIdx = stockists.findIndex(el => el.id == _preferred.id);
                    // stockist_arr.splice(foundIdx, 1);
                    // stockist_arr.unshift(_preferred);
                }

                if (preview) {
                    return stockist_arr.slice(0, 30);
                } else {
                    return stockist_arr.slice(0, 3);
                }

            },
            capitalize: function (str) {
                const arr = str.toLowerCase().split(" ");
                
                for (let i = 0; i < arr.length; i++) {
                    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
                }
                
                return arr.join(" ");
            },
            emailStockist: function (stockist) {
                const popup_btn = document.querySelector(".popup_stockist_enquiry--btn a[href*='#popup-']");
                const popup_form_name = document.querySelector("div[id^='popup-'] .popup_stockist_enquiry--form input[name='name']");
                const popup_form_email = document.querySelector("div[id^='popup-'] .popup_stockist_enquiry--form input[name='email']");
                const popup_form_phone = document.querySelector("div[id^='popup-'] .popup_stockist_enquiry--form input[name='phone']");

                console.log(stockist);
                if (popup_form_name) { popup_form_name.value = ""; }
                if (popup_form_email) { popup_form_email.value = ""; }
                if (popup_form_phone) { popup_form_phone.value = ""; }

                if (popup_btn) { popup_btn.click(); }
            }
        },
        mounted() {
            const { id, full_list, value, show } = this;
            this.id_data = id;
            this.show_data = parseInt(show);

            if (typeof this.stockists == 'string') {
                this.stockist_arr = JSON.parse(this.stockists);
            } else {
                this.stockist_arr = this.stockists;
            }

            if (value == 'stockist') {
                this.stockist_arr = full_list;
            }
        },
        watch: { 
            stockists: function(newVal) {
                if (typeof newVal === 'string') {
                    this.stockist_arr = JSON.parse(newVal);
                } else {
                    this.stockist_arr = newVal;
                }
            },
            show: function(newVal) {
                this.show_data = newVal === 'true' || newVal == 1;
            },
            id: function(newVal) {
                this.id_data = newVal;
            },
            absolute: function(newVal) {
                this.absolute_data = newVal === 'true' || newVal == 1;
            },
        },
        created () {
            this.GOOGLE_MAP_LINK = "https://maps.google.com?q="
        }
    }
</script>
  
<style lang="scss">
    @import "@/assets/global.scss";

    .availability-list-container {
        width: 100%;
        left: 0;
        
        .relative {
            z-index: 99;

            input[type='text'] {
                margin-top: 10px;
            }

            svg {
                position: absolute;
                top: 0px;
                left: 0px;
            }
            
            .svg-search, .spinner {
                position: absolute;
                top: 20px;
                right: 15px;
                left: unset;
                height: 23px;
                margin: 0;
            }

            .spinner > div {
                background-color: #ACAAAB;
            }

            @media screen and (min-width: 768px) {
                .spinner {
                    top: 20px;
                    right: 20px;
                }
            }
        }
        
        .address-list {
            position: absolute;
            top: 50px;
            left: 0;
            background: $white;
            border: 1px solid #D3D2D2;
            width: calc(100% - 2px);
            list-style: none;
            padding: 0;
            margin: 0;
            z-index: 999;
            max-height: 250px;
            overflow-y: scroll;
            text-align: left;

            li {
                padding: 10px 20px;
                border-bottom: 1px solid #D3D2D2;
                cursor: pointer;

                &:hover {
                    background: #EBF2F8;
                }
            }
        }

        .availability-list {
            max-height: 320px;
            overflow-y: auto;
            border-right: 1px solid #D3D2D2;
            border-bottom: 1px solid #D3D2D2;

            &.absolute {
                position: absolute;
                top: 50px;
                left: 0;
                right: 0;
                z-index: 999;
                border: 1px solid $pp-blue;
                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
            }

            .stockist-option { 
                padding: 10px 20px;
                display: flex;
                flex-direction: column;
                border: 1px solid #D3D2D2;
                border-top: none;
                background: $white; 

                &.active {
                    background: $pp-blue05;

                    .stockist-link {
                        cursor: auto;
                        pointer-events: none;
                    }
                }

                h4 {
                    font-weight: 500;
                    margin: 0;
                    display: inline-block;
                }

                span {
                    font-size: 14px;
                    color: #7B7979;
                    font-weight: 400;
                }

                svg {
                    margin-right: 5px;
                }

                .title-wrapper {
                    position: relative;

                    .d-flex {
                        align-items: center;
                    }

                    .alert {
                        display: inline-block;
                        color: #FF2F61;
                        vertical-align: text-top;
                        
                        path {
                            stroke: #FF2F61;
                        }

                        circle {
                            fill: #FF2F61;
                        }

                        svg {
                            position: relative;
                        }

                    }

                    .google-link {
                        cursor: pointer;
                        padding-left: 15px;
                    }
                
                }

                .content {
                    a {
                        text-decoration: none;

                        @media screen and (min-width: 768px) {
                            pointer-events: none;
                            cursor: pointer;
                        }
                    }

                    span {
                        padding-left: 20px;
                    }
                
                    svg {
                        width: auto;
                        height: auto;
                        top: 5px;
                    }
                }
            }

            &::-webkit-scrollbar {
                width: 10px;
                height: rem(12px);
            }
            /* Track */
            &::-webkit-scrollbar-track {
                background: $white;
                border-radius: rem(50px);
            }
            /* Handle */
            &::-webkit-scrollbar-thumb {
                background: $pp-grey60;
                border-radius: rem(50px);
                transition: all .3s ease-in-out;
            }
            /* Handle on hover */
            &::-webkit-scrollbar-thumb:hover {
                background: darken($pp-grey80, 10%);
            }

            .tooltip {
                display: inline-block;
                z-index: 998;
            }

            /* Tooltip text */
            .tooltip .tooltiptext {
                visibility: hidden;
                background-color: #FFE8EA;
                text-align: center;
                padding: 5px;
                border-radius: 6px;
                max-width: 200px;
                width: 100%;
                line-height: 20px;
                left: 0;
                right: 0;
                top: 50px;
                position: absolute;
                z-index: 1;


                span {
                    color: #FF2F61;
                }

                @media screen and (min-width: 520px) and (max-width: 767px) {
                    right: 100px;
                    left: unset;
                    top: 0;
                }

                @media screen and (min-width: 768px) and (max-width: 899px) {
                    right: 0px;
                    left: unset;
                    top: 50px;
                }

                @media screen and (min-width:  900px) {
                    right: 100px;
                    left: unset;
                    top: 0;
                }
            }

            /* Show the tooltip text when you mouse over the tooltip container */
            .tooltip:hover .tooltiptext {
                visibility: visible;
            }
        }

        &.preview {
            .availability-list {
                border: 1px solid #D3D2D2;
                border-radius: 2px;
                border-top: 0;
                border-bottom: 0;
                border-top-left-radius: 0;
                border-top-right-radius: 0;
                text-align: left;
                max-height: unset;
            }
            
            .link-wrapper {
                display: flex;
                gap: 10px;

                .link.relative {
                    padding-left: 15px;
                }
            }
        }
    }

    @media screen and (min-width: 1024px) {
        .woocommerce-cart .availability-list {
            max-height: 200px;
        }
    }

 </style>